import { Input } from "@/modules/shared/ui/components/input"
import { FaSearch } from "react-icons/fa"

interface SearchBarProps {
    placeholder?: string
    value: string
    onChange: (value: string) => void
    className?: string
}

export const SearchBar = ({
    placeholder = "Search...",
    value,
    onChange,
    className = ""
}: SearchBarProps) => {
    return (
        <div className={`relative ${className}`}>
            <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4" />
            <Input
                type="text"
                placeholder={placeholder}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                className="pl-10 w-full pr-4 py-3 border-0 focus-visible:ring-0 focus-visible:ring-offset-0"
            />
        </div>
    )
}